import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, message, Popconfirm, Image, Card } from 'antd';
import { getParks, addPark, updatePark, deletePark } from '../../services/parkService';

const Parks = () => {
  const [parks, setParks] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingPark, setEditingPark] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const fetchParks = async () => {
    try {
      const response = await getParks();
      console.log('Parks API Response:', response);
      if (response?.isSuccess) {
        setParks(response.data || []);
      } else {
        console.error('API response not successful:', response);
        message.error('Parklar yüklenemedi');
      }
    } catch (error) {
      console.error('Error fetching parks:', error);
      message.error('Parklar yüklenirken bir hata oluştu');
    }
  };

  useEffect(() => {
    fetchParks();
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64Data = reader.result;
        setImagePreview(base64Data);
        form.setFieldsValue({
          pictureBase64: base64Data.split(',')[1]
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (editingPark) {
        await updatePark({ ...values, guid: editingPark.guid });
        message.success('Park başarıyla güncellendi');
      } else {
        await addPark(values);
        message.success('Park başarıyla eklendi');
      }
      setIsModalVisible(false);
      form.resetFields();
      fetchParks();
    } catch (error) {
      message.error('İşlem sırasında bir hata oluştu');
    }
    setLoading(false);
  };

  const handleDelete = async (guid) => {
    try {
      await deletePark(guid);
      message.success('Park başarıyla silindi');
      fetchParks();
    } catch (error) {
      message.error('Silme işlemi sırasında bir hata oluştu');
    }
  };

  const columns = [
    {
      title: 'Resim',
      dataIndex: 'pictureUrl',
      key: 'pictureUrl',
      render: (pictureUrl) => (
        <Image
          src={pictureUrl}
          alt="Park"
          style={{ width: 100 }}
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
        />
      ),
    },
    {
      title: 'Park Adı',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Adres',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Harita URL',
      dataIndex: 'mapUrl',
      key: 'mapUrl',
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="primary" onClick={() => {
            setEditingPark(record);
            form.setFieldsValue(record);
            setIsModalVisible(true);
          }} style={{ marginRight: 8 }}>
            Düzenle
          </Button>
          <Popconfirm
            title="Bu parkı silmek istediğinizden emin misiniz?"
            onConfirm={() => handleDelete(record.guid)}
            okText="Evet"
            cancelText="Hayır"
          >
            <Button danger>Sil</Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div className="parks-page">
      <div className="arc-page-header">
        <h2>Parklar</h2>
        <Button
          type="primary"
          onClick={() => {
            setEditingPark(null);
            form.resetFields();
            setIsModalVisible(true);
          }}
        >
          Yeni Park Ekle
        </Button>
      </div>

      <Card>
        <Table columns={columns} dataSource={parks} rowKey="guid" />
      </Card>

      <Modal
        title={editingPark ? 'Parkı Düzenle' : 'Yeni Park Ekle'}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          form.resetFields();
          setEditingPark(null);
          setImagePreview(null);
        }}
        footer={null}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="name"
            label="Park Adı"
            rules={[{ required: true, message: 'Lütfen park adını giriniz' }]}
          >
            <input type="text" className="ant-input" />
          </Form.Item>

          <Form.Item
            name="address"
            label="Adres"
            rules={[{ required: true, message: 'Lütfen adresi giriniz' }]}
          >
            <input type="text" className="ant-input" />
          </Form.Item>

          <Form.Item
            name="mapUrl"
            label="Harita URL"
            rules={[{ required: true, message: 'Lütfen harita URL giriniz' }]}
          >
            <input type="text" className="ant-input" />
          </Form.Item>

          <Form.Item
            name="pictureBase64"
            label="Resim"
          >
            <div>
              <input 
                type="file" 
                onChange={handleFileChange} 
                accept="image/*" 
                key={isModalVisible ? 'open' : 'closed'}
              />
              {(imagePreview || (editingPark && editingPark.pictureUrl)) && (
                <div style={{ marginTop: 10 }}>
                  <Image
                    src={imagePreview || editingPark.pictureUrl}
                    alt="Preview"
                    style={{ maxWidth: 200 }}
                  />
                </div>
              )}
            </div>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editingPark ? 'Güncelle' : 'Ekle'}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Parks;
